import { ReservationCard } from '@/components/common/cards/reservation-card/ReservationCard';
import ErrorMessage from '@/components/common/error-message/ErrorMessage';
import GoBack from '@/components/common/go-back/GoBack';
import NoData from '@/components/common/no-data/NoData';
import { Skeleton } from '@/components/ui/skeleton';
import useReservationDetail from '@/hooks/pages/useReservationDetail';

const ReservationDetail = () => {
  const { reservation, isLoading, isFetching, isError, day, time, duration } =
    useReservationDetail();

  if (isLoading) {
    return (
      <>
        <GoBack />
        <Skeleton className="w-full h-4/5" />
      </>
    );
  }

  if (!reservation) {
    return (
      <>
        <GoBack />
        <NoData />
      </>
    );
  }

  if (isError) {
    return (
      <>
        <GoBack />
        <ErrorMessage />
      </>
    );
  }

  return (
    <>
      <GoBack />
      <div className="flex justify-center w-full">
        {
          <ReservationCard
            reservation={{
              id: reservation?.id,
              title: `${reservation?.user.firstName} ${reservation?.user.lastName} - ${reservation?.service.name}`,
              status: reservation?.reservationStatus?.name,
              day,
              time,
              endTime: reservation.endTime || undefined,
              startTime: reservation.startTime || undefined,
              duration,
              consumers: reservation.consumers.map((consumer) => {
                return {
                  id: consumer.id,
                  name: `${consumer.firstName} ${consumer.lastName}`,
                  weight: consumer.weight,
                  height: consumer.height,
                  equipment: consumer.equipment,
                  status: consumer.status
                };
              }),
              enabled: reservation.enabled,
              serviceSoldId: reservation.sale.id
            }}
            service={{
              id: reservation?.service?.id
            }}
            isFetching={isFetching}
          />
        }
      </div>
    </>
  );
};

export default ReservationDetail;
